import { useShallow } from 'zustand/react/shallow';
import isMatch from 'es-toolkit/compat/isMatch';
import { useAppContext } from '@pkgs/components/hooks/useAppContext';
import { useSearchStore } from '@pkgs/components/hooks/stores/search/useSearchStore';
import { type SearchState } from '@pkgs/components/hooks/stores/search/SearchStoreProvider';
import { Link } from '@ev-tech/ui-core-components/Link';
import { Button } from '@ev-tech/ui-core-components/Button';

import { PopoverClose } from '../Popover/Popover';

import styles from './LifestyleFilterDropdown.module.css';

export const FILTER_DROPDOWN_ACTIONS_TEST_IDS = {
  applyButton: 'search-components__lifestyle-filter-dropdown-actions__apply',
} as const;

export const LifestyleFilterDropdownActions = ({
  onApply,
  defaultState,
}: {
  onApply: (state: SearchState) => void;
  defaultState: Partial<SearchState>;
}) => {
  const { t } = useAppContext();
  const getStateSnapshot = useSearchStore((state) => state.getStateSnapshot);
  const shouldShowReset = useSearchStore(useShallow((state) => !isMatch(state, defaultState)));
  const resetState = useSearchStore((state) => state.resetState);

  return (
    <div className={styles.actionsContainer}>
      {shouldShowReset && <Link as="button" size="medium" onClick={() => resetState(defaultState)} label={t('search.searchbar.reset')} />}
      <PopoverClose
        render={
          <Button
            className={styles.applyButton}
            onClick={() => onApply(getStateSnapshot())}
            label={t('search.searchbar.apply')}
            testId={FILTER_DROPDOWN_ACTIONS_TEST_IDS.applyButton}
          />
        }
      />
    </div>
  );
};
